import React from 'react';
import { CardoList } from '@cotyorg/ccx-organism-cardo-list';

const FilterResults = ({
  filteredProducts = [],
  cardoListProps,
  breakpointConfig,
  cardoListId,
  onShowMoreClick,
}) => (
  <CardoList
    id={cardoListId}
    data={filteredProducts}
    breakpointConfig={breakpointConfig}
    onShowMoreClick={onShowMoreClick}
    {...cardoListProps}
  />
);

// TODO: [1] add missing prop types

export default FilterResults;
